import moment from "moment";
import { controlToastState } from "risa-oasis-ui_v2";
import { handleNarIngestionApiCall } from "./handleNarIngestionApiCall";

interface HandleNarIngestionUploadParams {
  selectedInsurance: string;
  selectedPlan: string;
  selectedDate: string;
  uploadedFiles: string[];
  fileType: "pdf" | "csv";
  onSuccess: () => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

export const handleNarIngestionUpload = async ({
  selectedInsurance,
  selectedPlan,
  selectedDate,
  uploadedFiles,
  fileType,
  onSuccess,
  setIsSubmitting,
}: HandleNarIngestionUploadParams) => {
  // Validation
  if (!selectedInsurance) {
    controlToastState("nar-ingestion-insurance-error");
    return;
  }

  if (!selectedPlan) {
    controlToastState("nar-ingestion-plan-error");
    return;
  }

  if (!selectedDate) {
    controlToastState("nar-ingestion-date-error");
    return;
  }

  if (uploadedFiles.length === 0) {
    controlToastState("nar-ingestion-file-error");
    return;
  }

  // Parse the date - it comes in YYYY-MM-DD format
  const date = moment(selectedDate);

  // Validate the date
  if (!date.isValid()) {
    controlToastState("nar-ingestion-date-error");
    return;
  }

  const month = date.month() + 1;
  const year = date.year();
  const day = date.date();

  await handleNarIngestionApiCall({
    payerType: selectedInsurance,
    subType: selectedPlan,
    month: month,
    year: year,
    documentType: fileType,
    ingest: false,
    day: day,
    onSuccess: onSuccess,
    setIsSubmitting: setIsSubmitting,
  });
};
